import {z} from 'zod'

export type ConnectionId = `conn-${string}`
export const ConnectionId = z.string().startsWith('conn-') as z.ZodType<ConnectionId>
